import { ReplaySubject } from 'rxjs';

import { Injectable } from '@angular/core';
import type { OnDestroy } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DestroyService extends ReplaySubject<void> implements OnDestroy {
  constructor() {
    super(1);
  }

  public ngOnDestroy(): void {
    this.next();
    this.complete();
  }
}
